import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Typewriter from "typewriter-effect";
import { AiFillLinkedin, AiFillMail } from "react-icons/ai";
import { FaWrench } from "react-icons/fa";
import { BsArrowRight } from "react-icons/bs";
import heroImg from "../../assets/hero-engineer.png";

function Home() {
  return (
    <section className="hero-section">
      <Container>
        <Row className="align-items-center">
          <Col md={7}>
            <div className="fade-in">
              <p className="hero-greeting">
                Hello <span className="wave-emoji">&#128075;</span>
              </p>
              <h1 className="hero-name">
                I'm <span className="purple">Debojyoti Roy</span>
              </h1>
              <div className="hero-typewriter">
                <Typewriter
                  options={{
                    strings: [
                      "Mechanical Engineer",
                      "Robotics Enthusiast",
                      "CAD and Simulation Expert",
                      "Design Engineer",
                      "Builder and Innovator",
                    ],
                    autoStart: true,
                    loop: true,
                    deleteSpeed: 40,
                  }}
                />
              </div>
              <p className="hero-description">
                IIT Kharagpur graduate passionate about the intersection of
                mechanical engineering, design, innovation and problem solving.
              </p>
              <div className="hero-cta">
                <Link to="/experience" className="btn-primary-custom">
                  View My Work <BsArrowRight />
                </Link>
                <Link to="/projects" className="btn-outline-custom">
                  <FaWrench /> Projects
                </Link>
              </div>
              <div className="social-icons fade-in fade-in-delay-2">
                <a
                  href="https://linkedin.com/in/debojyotir"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon"
                  title="LinkedIn"
                >
                  <AiFillLinkedin />
                </a>
                <a
                  href="mailto:debojyotir2025@gmail.com"
                  className="social-icon"
                  title="Email"
                >
                  <AiFillMail />
                </a>
              </div>
            </div>
          </Col>
          <Col md={5} className="hero-illustration fade-in fade-in-delay-3">
            <img
              src={heroImg}
              alt="Mechanical Engineer"
              style={{ width: "100%", maxWidth: "520px" }}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Home;
